export class TypeTransaction {

    tct_id: string;
    tct_ref: string;
    tct_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.tct_id         = data['tct_id'] ? data['tct_id'] : null;
        this.tct_ref        = data['tct_ref'] ? data['tct_ref'] : null;
        this.tct_libelle    = data['tct_libelle'] ? data['tct_libelle'] : null;
    }

}
